import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "2 0 26 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5286 13.2676L0.690918 24.7699C0.691936 24.772 0.691936 24.774 0.692954 24.7761C1.02479 26.026 2.16587 26.9452 3.51969 26.9452C4.06121 26.9452 4.56915 26.7986 5.00481 26.5421L5.03942 26.5218L17.238 19.4829L11.5286 13.2676Z",
			fill: "#EB4335"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.4925 11.3089L22.4823 11.3018L17.2156 8.24805L11.2822 13.5279L17.236 19.4807L22.4751 16.4585C23.3933 15.9628 24.0163 14.9947 24.0163 13.8781C24.0163 12.7696 23.4014 11.8056 22.4925 11.3089Z",
			fill: "#FABC13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.691063 2.93848C0.625917 3.1787 0.591309 3.43013 0.591309 3.69173V24.0163C0.591309 24.2779 0.624899 24.5304 0.691063 24.7696L11.9013 13.5614L0.691063 2.93848Z",
			fill: "#547DBF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.608 13.8535L17.2177 8.24583L5.0323 1.18154C4.58951 0.91587 4.07343 0.763184 3.51969 0.763184C2.16587 0.763184 1.02377 1.68439 0.690918 2.9354V2.93845L11.608 13.8535Z",
			fill: "#30A851"
		})
	]
});
export default SvgGoogle;
